import React from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import weeklyImg from "../images/weeklyPlan.png";
import reportImg from "../images/report.png";
import "./Home.css";

const Home = () => {
  let { sid, userid } = useParams();

  return (
    <div className="weeklyHome-container">
      <div className="weeklyHome-tiles">
        <Link
          to={`/weeklyPlan/${sid}/${userid}`}
          className="weeklyHome-tile"
          aria-label="Weekly Plan"
        >
          <span className="weeklyHome-iconWrap">
            <img className="weeklyHome-icon" src={weeklyImg} alt="" />
          </span>
          <h4 className="weeklyHome-title">Weekly Plan</h4>
        </Link>
        <Link
          to={`/weeklyReport/${sid}/${userid}`}
          className="weeklyHome-tile"
          aria-label="Report"
        >
          <span className="weeklyHome-iconWrap">
            <img className="weeklyHome-icon" src={reportImg} alt="" />
          </span>
          <h4 className="weeklyHome-title">Report</h4>
        </Link>
      </div>
    </div>
  );
};

export default Home;
